// extracted by mini-css-extract-plugin
module.exports = {"page1":"Page13_page1__1MQOI","bg":"Page13_bg__7dUgy","btn":"Page13_btn__LpT8C","formContent":"Page13_formContent__3PDZI","endImg":"Page13_endImg__1fIcl"};